import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "@similarweb/ui-components";

export const StyledFeaturesContainerWrapper = styled(FlexColumn)`
    justify-content: center;
    max-width: 1368px;
    margin-bottom: 138px;
`;

export const StyledFeaturesDescription = styled(FlexColumn)`
    ${mixins.setFontVariant("h6", colorsPalettes.carbon[400])}
    margin-bottom: 24px;
`;

export const StyledFeaturesHeader = styled(FlexRow)`
    ${mixins.setFontVariant("h5", colorsPalettes.carbon[500])}
    line-height: 24px;
    margin-bottom: 4px;
`;

export const StyledFeaturesContainer = styled(FlexRow)`
    gap: 24px;
    flex-wrap: wrap;
`;
